import {Field} from 'formik';
import {Container} from "@mantine/core";
import {
    FormikDateTimePicker,
    FormikNumberInput,
    FormikRadioGroup,
    FormikSelect,
    FormikTextarea,
    PlatformFieldset
} from "@flexinet/ui-components";
import {BillingChannel} from "../types.ts";
import {CustomersAutocomplete} from "../../customers/inputs/CustomersAutocomplete.tsx";
import {MetersAutocomplete} from "../../meters/inputs/MetersAutocomplete.tsx";

const enumOptions = (e: Record<string, string>) =>
    Object.values(e).map(value => ({label: value, value}));

export const FormComponent = () => {

    return (
        <Container>
            <PlatformFieldset legend={'Meter Assignment'}>
                <Field
                    name='customerId'
                    label='Customer'
                    description='Please select the customer'
                    component={CustomersAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='meterId'
                    label='Meter'
                    description='Please select the meter'
                    component={MetersAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='channel'
                    label='Channel'
                    description='The billing channel this assignment reports usage to'
                    component={FormikSelect}
                    data={enumOptions(BillingChannel)}
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Channel Identifiers'}>
                <Field
                    name='channelIdentifiers'
                    label='Channel Identifiers (JSON)'
                    description='JSON object — { "subscriptionItemId": "..." } for Stripe, or { "customerIdentifier": "...", "dimension": "..." } for AWS Marketplace'
                    component={FormikTextarea}
                    minRows={4}
                    autosize
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Quantities'}>
                <Field
                    name='freeTierQuantity'
                    label='Free Tier Quantity'
                    description='Usage granted before metered charges begin (optional)'
                    component={FormikNumberInput}
                    my={'xl'}
                />

                <Field
                    name='committedQuantity'
                    label='Committed Quantity'
                    description='Pre-committed usage volume (optional)'
                    component={FormikNumberInput}
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Effective Window'}>
                <Field
                    name='effectiveFrom'
                    label='Effective From'
                    description='When this assignment starts applying'
                    component={FormikDateTimePicker}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='effectiveTo'
                    label='Effective To'
                    description='When this assignment stops applying (optional)'
                    component={FormikDateTimePicker}
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Status'}>
                <Field
                    name='status'
                    label='Status'
                    description='Please select the status'
                    component={FormikRadioGroup}
                    data={[{
                        value: 'ACTIVE',
                        label: 'Active',
                    }, {
                        value: 'PAUSED',
                        label: 'Paused',
                    }, {
                        value: 'CANCELED',
                        label: 'Canceled',
                    }]}
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>

        </Container>
    );
};
